import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IRequestResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import CompanySubApplicationAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company-sub-application/company-sub-application.entity";
import {
  CreateCompanySubApplicationBody,
  UpdateCompanySubApplicationBody,
} from "./interfaces/company-sub-application.interface";

const apiUrl = env.API_CONFIGURATION_URL;
const moduleName = "company_sub_application";

@Injectable({
  providedIn: "root",
})
export class CompanySubApplicationService extends AbstractService<
  CompanySubApplicationAttributes,
  CreateCompanySubApplicationBody,
  UpdateCompanySubApplicationBody
> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Obtiene la lista de sub-aplicaciones con versiones configuradas para una compañía
   * GET /api/company_sub_application/{companyId}
   */
  findByCompanyId(companyId: string): Observable<IRequestResult<CompanySubApplicationAttributes[]>> {
    const url = `${apiUrl}api/${moduleName}/${companyId}`;
    return this.http.get<IRequestResult<CompanySubApplicationAttributes[]>>(url);
  }
}
